module.exports = __webpack_public_path__ + "img/waterLivestreamRoad.1aca7559.svg";